module.exports = __webpack_public_path__ + "static/img/ESCAMAS.47a1ee6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/files/ESCAMAS.jpg
// module id = V1ii
// module chunks = 2